import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  className?: string;
  inline?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  message = 'Loading...',
  className = '',
  inline = false
}) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  if (inline) {
    return <div className={`spinner ${sizeClasses[size]} ${className}`}></div>;
  }

  return (
    <div className={`loading ${className}`}>
      <div className="d-flex flex-column align-items-center">
        <div className={`spinner ${sizeClasses[size]}`}></div>
        {message && (
          <p className="mt-2 text-muted">{message}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;